export default __webpack_public_path__ + "static/media/tour-2.1758fbc9.svg";